<template>
  <FilterParent
    v-if="highestYearsOfExperience"
    :title="title"
    :aria-label-id="'years-of-experience-filter'"
    :start-open="true"
  >
    <div class="counselor-grid__filter-years-of-experience-container">
      <range-slider
        v-model="yearsOfExperience"
        :min="0"
        :max="highestYearsOfExperience"
        :aria-labelledby="'years-of-experience-filter'"
      />
    </div>
  </FilterParent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import FilterParent from '../common/FilterParent.vue';
import RangeSlider from 'Components/RangeSlider.vue';

export default defineComponent({
  name: 'YearsOfExperienceFilter',

  components: {
    FilterParent,
    RangeSlider,
  },

  data() {
    return {
      thumbPosition: '0%',
      progressWidth: '0%',
      isDragging: false,
      title: window.theme_vars.counselorGridTexts.yearsOfExperience,
    };
  },

  computed: {
    ...mapState('counselorGrid', ['highestYearsOfExperience']),

    yearsOfExperience: {
      get() {
        return this.$store.state.counselorGrid.filteredYearsOfExperience || 0;
      },
      set(value: number) {
        this.$store.commit('counselorGrid/setFilteredYearsOfExperience', value);
      },
    },
  },
});
</script>
